module.exports = __webpack_public_path__ + "ManCarryingPackageUnbranded.0b933bf64df207c25f223e69345044f2.png";